
/**
 * 강의 콘텐츠 유형
 */
export type LectureDetailResponseContentType = typeof LectureDetailResponseContentType[keyof typeof LectureDetailResponseContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LectureDetailResponseContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  VIDEO_MARKDOWN: 'VIDEO_MARKDOWN',
  QUIZ: 'QUIZ',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  TEXT: 'TEXT',
} as const;
